// extracted by mini-css-extract-plugin
export default {"container":"style_container__Kw0mx","logo":"style_logo__mUWWk","copyright":"style_copyright__BWcra"};